import { truncate } from 'lodash-es';
import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { MayBeNil } from 'app/@types/utils/may-be-nil';
import { MOBILE_BREAK_POINT } from 'app/constants';
import useIsMobile from 'hooks/use-is-mobile';
import { SummaryEntry } from 'main/changelog';
import formatDate from 'utils/format-date';

import ArrowLeftIcon from './assets/arrow-left.svg';
import { useStyles } from './styles';

type Props = {
    prevSummary: MayBeNil<SummaryEntry>;
    nextSummary: MayBeNil<SummaryEntry>;
};

const Navigation: React.FC<Props> = ({ prevSummary, nextSummary }) => {
    const { classes, cx } = useStyles();
    const isMobile = useIsMobile(MOBILE_BREAK_POINT);
    const ellipsis = useCallback((text: string) => truncate(text, { length: isMobile ? 35 : 100 }), [isMobile]);

    return (
        <div className={classes.wrapper}>
            {prevSummary ? (
                <Link className={cx(classes.side, classes._left)} to={`/changelog/${prevSummary.id}`}>
                    <div className={classes.text}>
                        <span className={classes.title} title={prevSummary.title}>
                            {ellipsis(prevSummary.title)}
                        </span>
                        <span className={classes.date}>{formatDate(prevSummary.date, 'MMMM d, yyyy')}</span>
                    </div>
                    <ArrowLeftIcon className={classes.arrow} />
                </Link>
            ) : null}

            {nextSummary ? (
                <Link className={cx(classes.side, classes._right)} to={`/changelog/${nextSummary.id}`}>
                    <div className={classes.text}>
                        <span className={classes.title} title={nextSummary.title}>
                            {ellipsis(nextSummary.title)}
                        </span>
                        <span className={classes.date}>{formatDate(nextSummary.date, 'MMMM d, yyyy')}</span>
                    </div>
                    <ArrowLeftIcon className={cx(classes.arrow, classes._rotated)} />
                </Link>
            ) : null}
        </div>
    );
};

export default Navigation;
